import React, { useEffect, useRef, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import styles from "./scss/initialcheck.module.scss";
import { Row, Col, Dropdown, Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';
const InitialChecks = (props: any) => {
  const navigate = useNavigate();
  const nextPage = () => {
    //props.setinitialChecks(true)
    //props.pageset(props.page + 1)
    //window.location.href="/portnumber/step2";
    navigate("/portnumber/step2")
  }
  const BackPage = () => {
    navigate("/port-in")
  }

  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const handleToggleOptions = () => {
    setIsOptionsVisible(prevState => !prevState);
  };
  const options = [
    { value: 'active', label: 'Initial Checks' },
    { value: 'closed', label: 'Basic Info' },
    { value: 'closed', label: 'Select Numbers' },
    { value: 'closed', label: 'Number Mapping' },
    { value: 'closed', label: 'Letter of Authorization' },
  ];
  const [key, setKey] = useState('active');
  const selectedLabel = options.find(option => option.value === key)?.label || "Select an option";
  const selectBoxRef = useRef<any>(null);

  const handleOptionClick = (value: any) => {
    setKey(value);
    setIsOptionsVisible(false);
  };
  return (
    <>

      <Row className="breadcrumbarea">
        <Col sm={12}>
          <h4>Port In
            <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.847363 11.6654C0.654963 11.6654 0.462564 11.5922 0.316164 11.4447C0.0236636 11.1517 0.0246635 10.6771 0.318163 10.3842L4.18246 6.53168C4.32456 6.39008 4.40266 6.20058 4.40266 5.99948C4.40266 5.79928 4.32456 5.61078 4.18246 5.46918L0.317764 1.61568C0.0247639 1.32268 0.0238637 0.848079 0.316264 0.555179C0.608264 0.261279 1.08336 0.261279 1.37726 0.553179L5.24156 4.40668C5.66736 4.83148 5.90216 5.39688 5.90266 5.99948C5.90316 6.60208 5.66826 7.16748 5.24156 7.59418L1.37686 11.4467C1.23086 11.5922 1.03876 11.6654 0.847363 11.6654Z" fill="black" />
            </svg>
            <span>Port Number</span></h4>
          <p>Port in phone number(s) from your current service provider without any interruptions at free of cost</p>
        </Col>
      </Row>
      <Row className="nopadding basicinfocheck">
        <Col sm={12} className="nopadding basicinfocheck">

          {/* <div className="mobileselect">
            <div className="selectbox" ref={selectBoxRef}>
              <div className="selectboxname" onClick={handleToggleOptions}>
                {selectedLabel}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                  <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="black" />
                </svg>
              </div>
              {isOptionsVisible && (
                <div className="selectboxoption">
                  <ul>
                    {options.map(option => (
                      <li key={option.value} onClick={() => handleOptionClick(option.value)}>
                        {option.label}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div> */}
          <div className={styles.initialcheckactive}>
            <ul>
              <li>Initial Checks</li>
            </ul>
          </div>

          <div className={styles.portnumllist}>
            <ul>
              <li className={styles.active}><span>1</span>Initial Checks</li>
              <li><span>2</span>Basic Info</li>
              <li><span>3</span>Select Numbers</li>
              <li><span>4</span>Number Mapping</li>
              <li><span>5</span>Letter of Authorization</li>
            </ul>
          </div>
          <div>

          </div>
          <div className={styles.mainscroll}>

            <Row className={styles.scrolldiv}>
              <Col sm={12} className="nopadding">
                <div className={styles.initialcheck}>
                  <h5>Before you begin, please do the following checks to make sure that the business phone number(s) you are porting meet the following number porting requirements.</h5>
                  <ul>
                    <li>Phone numbers should be portable and active with the current service provider</li>
                    <li>The information you provide must exactly match with your customer service record (CSR) with the current service provider.</li>
                    <li>Ensure the current service provider has unlocked the numbers if applicable.</li>
                    <li>If current provider requires a PIN for number porting, then have the PIN ready when creating the port order.</li>
                    <li>Ensure all numbers in the port order are associated with the main billing phone number on the account with the current service provider.</li>
                    <li>Remove any special services associated with your existing numbers, such as DSL Internet, Call Forwarding, or hunt groups.</li>
                    <li>Don't cancel your existing service until Worktual notifies you that the number port is complete. Else, your porting request will be completed but your number will be disconnected.</li>
                    <li>Cancel any open service requests with your current service provider.</li>
                    <li>All numbers in the port request should belong to the same service provider. If you use multiple service providers, then you need to create a separate port request for each service provider.</li>
                    <li>Can enable temporary numbers with Worktual to forward calls made to your original number to this number until the porting process is complete.</li>
                  </ul>
                </div>
              </Col>

            </Row>


          </div>

          <div className={`${styles.bottombtn} bottombtn`}>
            <div className={styles.bottomareainner}>
              <button onClick={BackPage} className="cancelbtn">Cancel</button>
              <button onClick={nextPage} className="">Next</button>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default InitialChecks;
